import { render, staticRenderFns } from "./menuDisplay.vue?vue&type=template&id=e1ff546c&"
import script from "./menuDisplay.vue?vue&type=script&lang=js&"
export * from "./menuDisplay.vue?vue&type=script&lang=js&"
import style0 from "./menuDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports